import React from 'react'
import {Component} from 'react'
import debounce from 'debounce'
import VendorCount from './vendor-count'
import toClassName from '../functions/to-class-name'
import { SCREENMDMIN, SCREENSMMIN } from '/js/variables/breakpoints'
import './datenav.scss'

export default class DateNav extends Component {
  state =  {
    currentPage: 0,
    pageLength: DateNav.maxPageLength,
  }
  static get maxPageLength(){
    let length = 3
    if( window.innerWidth < SCREENMDMIN ) length--
    if( window.innerWidth < SCREENSMMIN ) length--
    return length
  }
  get totalPages(){
    return Math.ceil( this.props.events.length / this.state.pageLength )
  }

  nextPage = () => {
    this.goToPage('next')
  }
  prevPage = () => {
    this.goToPage('prev')
  }
  goToEventPage = () => {
    let index = this.props.events.findIndex( event => {
      return this.props.event.id == event.id
    } )
    let page = Math.floor(index / this.state.pageLength)
    if( page != this.state.currentPage && page >= 0 ) this.goToPage( page )
  }
  goToPage = which => {
    let page = this.state.currentPage
    switch ( which ) {
      case 'next':
        page++
        break;
      case 'prev':
        page--
        break;
      default:
        page = which
    }
    if( page < 0 ) page = 0
    if( page > this.totalPages - 1 ) page = this.totalPages - 1
    page = Math.floor( page )
    this.setState( { currentPage: page } )
    if( this.state.pageLength == 1 ) this.props.setEvent( this.props.events[ page ] )
  }
  setPageLength = debounce( () => {
    this.setState( { pageLength: DateNav.maxPageLength } )
  }, 200 )
  setEvent = event => {
    this.props.setEvent( event )
  }
  theEventClasses = event => {
    var classes = ['datenav__date', 'date']
    if( this.props.event && this.props.event.id == event.id )
      classes.push('current')
    return toClassName( classes )
  }
  theEvents = () => {

    let start = this.state.currentPage * this.state.pageLength
    return this.props.events.slice( start , start + this.state.pageLength ).map( ( event, index ) => {
      const iso = new Date(event.startTime._date.ts).toISOString()
 
      return (
        <li
          key={event.id}
          className={ this.theEventClasses( event ) }
          onClick={ function(){ this.setEvent( event ) }.bind(this) }
          >
          <meta itemProp="name" content={ event.name }/>
          <meta itemProp="startDate" content={ iso } />
          <span className="day">{ event.startTime.getWeekDay() }</span>
          <span className="month-day">{ event.startTime.getMonth()}/{ event.startTime.getDate() }</span>
          <span className="datenav__time"><i className="fa fa-clock-o"></i> { event.timeSpan }</span>
          <VendorCount count={ event.assignedVendors } />
        </li>
      )
    } )
  }
  componentDidMount(){
    window.addEventListener( "resize", this.setPageLength )
    if ( ! this.props.event ){
      this.setEvent( this.props.events[0] )
    } else {
      this.goToEventPage()
    }
  }
  componentDidUpdate( prevProps, prevState ){
    if(
      (
        prevProps.event &&
        prevProps.event.id != this.props.event.id
      ) ||
      prevState.pageLength != this.state.pageLength
    ){
      this.goToEventPage()
    }
  }
  componentWillUnmount(){
    window.removeEventListener( "resize", this.setPageLength )
  }
  render(){
    var prev = this.state.currentPage < 1 ? ' disabled' : ''
    var next = this.state.currentPage < this.totalPages - 1 ? '' : ' disabled'
    var multiplePages = this.props.events.length > this.state.pageLength
    return (
      <div className="datenav__wrap">
        { multiplePages && <button className={'btn-prev fa fa-angle-left' + prev } onClick={ this.prevPage }></button> }
        <ul className="datenav event-dates">
          { Array.isArray(this.props.events) && this.theEvents()}
        </ul>
        { multiplePages && <button className={'btn-next fa fa-angle-right' + next} onClick={ this.nextPage }>{''}</button> }
      </div>
    )
  }
}
